// Тумблер «Автовыбор отрядов» в меню матча (change unit-auto-selection):
// выбор игрока запоминается в браузере и действует во всех партиях. По
// умолчанию автовыбор включен. Хранилище может быть недоступно (приватное
// окно, запрет сайта) — тогда тумблер просто живет до перезагрузки
export const LOCAL_STORAGE_KEY_UNIT_AUTO_SELECTION = 'strategikon.unitAutoSelection';

// Модуль исполняет и Node-сервер (редьюсер приватного стейта): там хранилища нет
const getStorage = () => (typeof localStorage === 'undefined' ? null : localStorage);

export const readUnitAutoSelectionEnabled = () => {
  try {
    return getStorage()?.getItem(LOCAL_STORAGE_KEY_UNIT_AUTO_SELECTION) !== 'off';
  } catch (e) {
    return true;
  }
};

export const writeUnitAutoSelectionEnabled = (isEnabled) => {
  try {
    getStorage()?.setItem(LOCAL_STORAGE_KEY_UNIT_AUTO_SELECTION, isEnabled ? 'on' : 'off');
  } catch (e) {
    // Не сохранилось — тумблер действует до перезагрузки
  }
};
